import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Typography, IconButton, Button } from '@mui/material';
import { motion } from 'framer-motion';
import CustomButton from '../../CustomButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ScrollArea from 'react-scrollbar';
import { makeStyles } from '@material-ui/styles';
import styles from '../style.module.css';
import { getSelectedNode } from '../dashboard.utils';
import { updateNoded } from '../../../redux/actions/uiActions';
import backIcon from '../../../assets/images/svg/backIcon.svg';

const variants = {
  final: { y: 0, opacity: 1, transition: { duration: 0.4, type: 'tween' } },
  plus: { y: 50, opacity: 0 },
  minus: { y: -50, opacity: 0 },
};

const CreateNode = ({ onClick, currentCard }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [total, setTotal] = useState(1);
  const [hoverImg, setHoverImg] = useState(false);
  const [stepState, setStepState] = useState(1);
  const [animateNum, setAnimateNum] = useState(false);

  const nodeBtnClickHandler = () => {
    if (stepState === 1) {
      setStepState(2);
    } else {
      dispatch(updateNoded(currentCard - 1, total));
    }
  };

  const handleClick = () => {
    onClick(false);
  };

  const increament = () => {
    if (total === '') {
      setTotal(1);
      setAnimateNum(true);
    } else {
      setTotal(parseInt(total) <3 ? parseInt(total) + 1 : parseInt(total));
      setAnimateNum(true);
    }
  };

  const decrement = () => {
    if (total > 1) {
      setTotal(total - 1);
      setAnimateNum(false);
    }
  };

  const handleInput = (e) => {
    const re = /^[0-9\b]+$/;

    if (total !== '') {
      if (e.target.value === '' || re.test(e.target.value)) {
        setTotal(e.target.value);
      }
    } else {
      if (re.test(e.target.value)) {
        setTotal(e.target.value);
      }
    }
  };
  const selectedNode = getSelectedNode(currentCard);

  const useStyles = makeStyles((theme) => ({
    tabsBtn: {
      background: theme.palette.background.nTabsBg,
      border: '1px solid',
      borderColor: theme.palette.border.tabsActiveBorder,
    },
  }));
  const classes = useStyles();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'fles-start',
      }}
      className={styles.childNodeContainer}
      flexDirection={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
    >
      <Box flex={1} sx={{ textAlign: 'center' }}>
        <Button
          sx={{ padding: '0', position: 'relative' }}
          onMouseOver={() => setHoverImg(true)}
          onMouseOut={() => setHoverImg(false)}
          onClick={handleClick}
          className={styles.btnImage}
        >
          <img
            src={!hoverImg ? selectedNode.img : selectedNode.hoverImg}
            className={styles.right}
            width="176px"
            height="248px"
            alt="card"
          />
          <img
            className={styles.left}
            src={!hoverImg ? selectedNode.img : selectedNode.hoverImg}
            width="176px"
            height="248px"
            alt="card"
          />
          <img
            src={!hoverImg ? selectedNode.img : selectedNode.hoverImg}
            width="189px"
            height="265px"
            alt="card"
            style={{
              zIndex: 1,
              boxShadow: 'box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.64),0px -1px 32px rgba(222, 191, 112, 0.1)',
            }}
          />
          <Box className={styles.backWrap}>
            <Link to="/">
              <img src={backIcon} alt="..." />
            </Link>
          </Box>
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'space-around', marginTop: '18px' }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: 'white',
                fontFamily: 'Kanit',
                fontSize: '12px',
                textAlign: 'left',
                lineHeight: 1,
              }}
            >
              COST
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                lineHeight: 1,
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
                marginTop: '4px',
                fontSize: '24px',
              }}
            >
              {selectedNode.cost}
            </Typography>
          </Box>
          <Box sx={{ border: '1px solid #424242' }}></Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="subtitle1"
              sx={{
                lineHeight: 1,
                color: 'white',
                fontFamily: 'Kanit',
                fontSize: '12px',
              }}
            >
              REWARDS
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                lineHeight: 1,
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
                fontSize: '24px',
                marginTop: '4px',
              }}
            >
              {selectedNode.rewards}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box flex={2} sx={{ paddingX: 6, paddingY: 4 }}>
        <Box>
          <Box
            maxWidth={'340px'}
            sx={{
              margin: '0 auto',
              border: '0',
              height: '30px',
              display: 'flex',
              overflow: 'hidden',
            }}
          >
            {value === 0 ? (
              <Button
                className={classes.tabsBtn}
                fullWidth
                sx={{
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                  color: 'white',
                  borderRadius: '20px 0px 0px 20px',
                  padding: '10px',
                  fontSize: '10px',
                  borderTop: '1px solid #ccc',
                }}
                size="small"
              >
                new
              </Button>
            ) : (
              <Button
                fullWidth
                sx={{
                  color: 'white',
                  padding: '10px',
                  fontSize: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '20px 0px 0px 20px',
                }}
                onClick={() => setValue(0)}
                size="small"
              >
                new
              </Button>
            )}

            {value === 1 ? (
              <Button
                className={classes.tabsBtn}
                fullWidth
                sx={{
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                  color: 'white',
                  borderRadius: '0',
                  padding: '10px',
                  fontSize: '10px',
                }}
                size="small"
              >
                compound
              </Button>
            ) : (
              <Button
                fullWidth
                sx={{
                  color: 'white',
                  padding: '10px',
                  fontSize: '10px',
                  border: '1px solid #ccc',
                  borderRadius: 0,
                }}
                onClick={() => setValue(1)}
                size="small"
              >
                compound
              </Button>
            )}

            {value === 2 ? (
              <Button
                fullWidth
                className={classes.tabsBtn}
                sx={{
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                  color: 'white',
                  borderRadius: '0 20px 20px 0',
                  padding: '10px',
                  fontSize: '10px',
                }}
                size="small"
              >
                combine
              </Button>
            ) : (
              <Button
                fullWidth
                sx={{
                  color: 'white',
                  padding: '10px',
                  fontSize: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '0 20px 20px 0',
                }}
                onClick={() => setValue(2)}
                size="small"
              >
                combine
              </Button>
            )}
          </Box>
        </Box>
        <Box marginTop={2}>
          <Typography
            sx={{
              color: 'white',
              fontFamily: 'Kanit',
              textAlign: 'center',
              fontSize: '13px',
              lineHeight: '21px',
            }}
          >
            Number of Nodes
          </Typography>

          <Box display={'flex'} alignItems="center" marginTop={4}>
            <Box flex={1} sx={{ textAlign: 'center' }}>
              <IconButton aria-label="remove" size="large" onClick={decrement}>
                <RemoveIcon sx={{ color: 'white' }} fontSize="large" />
              </IconButton>
            </Box>
            <Box
              flex={1}
              sx={{
                width: '80px',
                backgroundColor: '#23242C',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
            >
              {/* <input
                type="text"
                value={total}
                onChange={handleInput}
                style={{
                  width: '100%',
                  height: '103px',
                  background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%)',
                  border: 'transparent',
                  color: '#FFF4D1',
                  fontSize: '90px',
                  webkitBackgroundClip: 'text',
                  webkitTextFillColor: 'transparent',
                  textFillColor: 'transparent',
                  textAlign: 'center',
                  fontWeight: 500,
                }}
                
              /> */}
              <motion.h2
                variants={variants}
                animate={`final`}
                initial={animateNum ? 'plus' : 'minus'}
                key={total}
                style={{
                  width: '100%',
                  height: '103px',
                  background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%)',
                  border: 'transparent',
                  color: '#FFF4D1',
                  fontSize: '90px',
                  webkitBackgroundClip: 'text',
                  webkitTextFillColor: 'transparent',
                  textFillColor: 'transparent',
                  textAlign: 'center',
                  fontWeight: 500,
                }}
              >
                {total}
              </motion.h2>
            </Box>
            <Box flex={1} sx={{ textAlign: 'center' }}>
              <IconButton aria-label="delete" size="large" onClick={increament}>
                <AddIcon sx={{ color: 'white' }} fontSize="large" />
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Box marginTop={2}>
          <Typography
            sx={{
              color: 'white',
              fontFamily: 'Kanit',
              textAlign: 'center',
              fontSize: '15px',
            }}
          >
            TOTAL
          </Typography>
          <Typography
            sx={{
              color: 'white',
              fontFamily: 'Kanit',
              textAlign: 'center',
              background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%)',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 500,
              fontSize: '20px',
            }}
          >
            {selectedNode.cost * total} THOR
            {/* {selectedNode.name} */}
          </Typography>
        </Box>
      </Box>
      <Box flex={2} paddingX={2} paddingY={4}>
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            fontFamily: 'Kanit',
            fontWeight: 500,
            opacity: 0.6,
          }}
        >
          Step {stepState} of 2
        </Typography>

        {/* <Box className={`${styles.appinput} ${styles.activeBorder}`}>Active State</Box> */}

        <ScrollArea
          speed={0.8}
          contentClassName="content"
          horizontal={false}
          // style={{ height: '20vh', marginTop: '10px' }}
          style={{ marginTop: '10px' }}
        >
          {total > 0 ? (
            <>
              {Array(parseInt(total))
                .fill(0)
                .map((v) => (
                  <input key={v} className={`${styles.appinput} ${styles.activeBorder}`} placeholder="Name your node" />
                ))}
            </>
          ) : null}
        </ScrollArea>

        <Box sx={{ textAlign: 'right', marginTop: 2 }}>
          {/* {total > 1 ? <CustomButton label="Create Nodes" /> : <CustomButton label="Create Node" />} */}
          <CustomButton
            onClick={nodeBtnClickHandler}
            label={stepState === 1 ? `APPROVE CONTRACT` : `Create Node${total < 2 ? '' : 's'}`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CreateNode;
